import { Navigate } from "@tanstack/react-router";
import { ScopeUI } from "@corpuscomplete/core-ui/common/scope";
import { useAuth } from "@corpuscomplete/web/auth/hooks";
import {
  readLastScopedRouteScope,
  writeLastScopedRouteScope,
} from "@corpuscomplete/web/modules/common/last-scoped-route-scope";
import { Scope } from "@corpuscomplete/core/common/scope";

export function RecipesIntentNavigate() {
  const scope = useValidatedIntentScope();

  if (!scope) {
    return null;
  }

  if (scope.kind === "space") {
    return <Navigate to="/spaces/$spaceId/recipes" params={{ spaceId: scope.spaceId }} replace />;
  }

  return <Navigate to="/personal/recipes" replace />;
}

export function CollectionsIntentNavigate() {
  const scope = useValidatedIntentScope();

  if (!scope) {
    return null;
  }

  if (scope.kind === "space") {
    return (
      <Navigate to="/spaces/$spaceId/collections" params={{ spaceId: scope.spaceId }} replace />
    );
  }

  return <Navigate to="/personal/collections" replace />;
}

export function PlannedMealsIntentNavigate() {
  const scope = useValidatedIntentScope();
  const date = Temporal.Now.plainDateISO();

  if (!scope) {
    return null;
  }

  if (scope.kind === "space") {
    return (
      <Navigate
        to="/spaces/$spaceId/planned-meals/$date"
        params={{ spaceId: scope.spaceId, date }}
        replace
      />
    );
  }

  return <Navigate to="/personal/planned-meals/$date" params={{ date }} replace />;
}

export function MealPlanningSessionsIntentNavigate() {
  const scope = useValidatedIntentScope();

  if (!scope) {
    return null;
  }

  if (scope.kind === "space") {
    return (
      <Navigate
        to="/spaces/$spaceId/meal-planning-sessions"
        params={{ spaceId: scope.spaceId }}
        replace
      />
    );
  }

  return <Navigate to="/personal/meal-planning-sessions" replace />;
}

function useValidatedIntentScope(): Scope.Info | null {
  const { userId } = useAuth();
  const scope = readLastScopedRouteScope(userId);
  return ScopeUI.useAccessibleScope(scope, userId, {
    onInaccessibleScope: () => writeLastScopedRouteScope(userId, Scope.personal(userId)),
  });
}
